import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Container = styled(Box)`
  display: flex;
  gap: 15px;
  align-items: center;
  padding-bottom: 40px;
  flex-direction: column;
`;
